type ResolveFunction = (value: boolean) => void

type ConfirmationOptions = {
  title: string
  description: string
  cancelMessage?: string
  confirmMessage?: string
}

export default function useConfirmation() {
  const confirmation = useState<ConfirmationOptions | null>(
    'confirmation',
    () => null
  )

  const resolveCallback = useState<ResolveFunction | null>(
    'confirmationResolveCallback',
    () => null
  )

  function openConfirmation(options: ConfirmationOptions) {
    confirmation.value = options

    return new Promise((resolve) => {
      resolveCallback.value = resolve
    })
  }

  function closeConfirmation() {
    confirmation.value = null
  }

  function confirm() {
    if (resolveCallback.value) {
      resolveCallback.value(true)
    }
    closeConfirmation()
  }

  function cancelConfirmation() {
    closeConfirmation()
  }

  return {
    confirmation,
    openConfirmation,
    confirm,
    cancelConfirmation
  }
}
